import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomeUltimate from "./pages/HomeUltimate";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomeUltimate />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
